// src/locales/en/profile.js
export const profile = {
  editProfile: "Edit Profile",
  myProfile: "My Profile",
  updateProfileDesc: "Update your personal information and account settings",

  // Sections
  personalInformation: "Personal Information",
  personalInformationDesc: "Update your name, phone, address and birthday",
  profilePicture: "Profile Picture",
  profilePictureDesc: "Upload a profile picture (optional)",
  accountInformation: "Account Information",
  accountInformationDesc: "Your email address and role (read only)",
  assignedResources: "Assigned Resources",
  assignedResourcesDesc: "Your shop and warehouse assignments (managed by admin)",
  changePassword: "Change Password",
  changePasswordDesc: "Update your account password",

  // Fields
  fullName: "Full Name",
  fullNamePlaceholder: "Enter your full name",
  emailAddress: "Email Address",
  phoneNumber: "Phone Number",
  phonePlaceholder: "Enter your phone number",
  address: "Address",
  addressPlaceholder: "Enter your address",
  birthday: "Birthday",
  userRole: "Role",
  assignedShops: "Assigned Shops",
  assignedWarehouses: "Assigned Warehouses",
  noShopsAssigned: "No shops assigned",
  noWarehousesAssigned: "No warehouses assigned",
  defaultShop: "Default Shop",
  defaultWarehouse: "Default Warehouse",

  // Password fields
  currentPassword: "Current Password",
  currentPasswordPlaceholder: "Enter current password",
  newPassword: "New Password",
  newPasswordPlaceholder: "Enter new password",
  confirmNewPassword: "Confirm New Password",
  confirmNewPasswordPlaceholder: "Confirm new password",

  // Profile picture
  clickToUpload: "Click to upload profile picture",
  profilePictureFormats: "PNG, JPG, WEBP up to 2MB",
  removePhoto: "Remove photo",

  // Validation
  nameRequired: "Name is required",
  currentPasswordRequired: "Current password is required",
  newPasswordRequired: "New password is required",
  newPasswordMinLength: "New password must be at least 6 characters",
  confirmPasswordRequired: "Please confirm your new password",
  passwordsDoNotMatch: "Passwords do not match",
  invalidPhone: "Please enter a valid phone number",
  invalidProfilePictureFormat: "Profile picture must be PNG, JPG, JPEG, or WEBP format",
  profilePictureTooLarge: "Profile picture must be less than 2MB",

  // Loading/Error states
  loadingProfile: "Loading Profile...",
  loadingProfileDesc: "Please wait while we fetch your profile data.",
  failedToLoadProfile: "Failed to load profile data. Please try again.",

  // Actions
  saveChanges: "Save Changes",
  noChanges: "No Changes",
  updatePassword: "Update Password",

  // Success/Error messages
  profileUpdatedSuccess: "Profile updated successfully!",
  failedToUpdate: "Failed to update profile. Please try again.",
  passwordChangedSuccess: "Password changed successfully!",
  failedToChangePassword: "Failed to change password. Please try again.",
  confirmDiscardChanges: "You have unsaved changes. Are you sure you want to leave?",
  discardChanges: "Discard Changes",
  noChangesToSave: "No changes to save.",
};
